import { Grid } from '@/styles/grid'

import AppLinks from '@/components/parking/AppLinks'
import CustomReveal from '@/components/common/CustomReveal'

import { Container, OpinionsWrapper, StarsWrapper } from './Navipay.styled'
import Stars from './Stars'

function Navipay() {
  return (
    <Container id="navipay-section">
      <CustomReveal>
        <Grid>
          <StarsWrapper>
            <Stars />
          </StarsWrapper>
          <OpinionsWrapper>
            <AppLinks />
          </OpinionsWrapper>
        </Grid>
      </CustomReveal>
    </Container>
  )
}

export default Navipay
